import React from 'react'
import { formatAgo, formatDateTime } from '../../../../shared/sso-workspace/format'

// The alert routing drawers' sections (owner 2026-10-30: "a flat label/value
// dump"): the API key form's -- a small heading, then its content, a hairline
// before the next (api-key-create-drawer.js FormSection). `aside` sits at the
// heading's right (a count, a link).
export const DrawerSection = ({ title, aside, children, testId }) =>
  <section className="ar-dsection" aria-label={title} data-testid={testId}>
    <div className="ar-dsection-head">
      <h3 className="ar-dsection-heading">{title}</h3>
      {aside && <div className="ar-dsection-aside">{aside}</div>}
    </div>
    {children}
  </section>

// "2 hours ago", the exact local time on hover.
export const Ago = ({ at }) => (at ? <span title={formatDateTime(at)}>{formatAgo(at)}</span> : null)
